import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data.user); setCompany(data.company); })
      .catch(() => { localStorage.removeItem("token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user); setCompany(data.company);
    return data;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/tenants/signup", payload);
    localStorage.setItem("token", data.token);
    setUser(data.user); setCompany(data.company);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null); setCompany(null);
  };

  const refreshMe = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data.user); setCompany(data.company); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, signup, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
